if (window.BASE_HOST) {
  __webpack_public_path__ = window.BASE_HOST + '/'; // eslint-disable-line
}
